var r=function(r,a,n){var t=n-1;(a<0||a>=n)&&(a=r>0?-1:t+1);var v=a+r;return v<0?t:v>t?0:v};export{r as getNextIndex};
